/* Eclipse Sample Sales — chantier 1
   Real-time state (LIVE/UPCOMING/PAST) + countdown for .ec-city-section cards.

   Strategy:
   - Server-side Liquid renders an initial state. CDN caching can make it stale
     by several minutes. On mount, we recompute immediately so the visible state
     is corrected within ~50ms before any countdown tick.
   - One global setInterval(1000) drives all sections. Scopes are tracked via
     `mountedSections` so that the interval is cleared when the last section
     unmounts (Shopify theme editor DesignMode). */

(function () {
  'use strict';

  var SECTION_CLASS = 'ec-city-section';
  var SECTION_SELECTOR = '.' + SECTION_CLASS;
  var CARD_SELECTOR = '[data-eclipse-card]';

  var tickHandle = null;
  var mountedSections = new Set();

  function parseIso(str) {
    if (!str) return null;
    var t = Date.parse(str);
    return isNaN(t) ? null : t;
  }

  function computeState(startMs, endMs, now) {
    if (endMs && now >= endMs) return 'past';
    if (startMs && now >= startMs) return 'live';
    return 'upcoming';
  }

  function pad2(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function updateCard(card, now) {
    try {
      var override = card.getAttribute('data-state-override') || '';
      var startRaw = card.getAttribute('data-eclipse-start');
      var endRaw = card.getAttribute('data-eclipse-end');
      var start = parseIso(startRaw);
      var end = parseIso(endRaw);

      if (startRaw && start === null) {
        console.error('[eclipse-brand-cards] invalid start date', startRaw, card);
      }
      if (endRaw && end === null) {
        console.error('[eclipse-brand-cards] invalid end date', endRaw, card);
      }

      var state = override || computeState(start, end, now);
      if (card.getAttribute('data-state') !== state) {
        card.setAttribute('data-state', state);
      }
      if (state === 'past') return;

      var ct = card.querySelector('[data-eclipse-countdown]');
      if (!ct) return;

      var targetAttr = ct.getAttribute('data-target');
      var target = targetAttr === 'end' ? end : start;
      if (!target) return;

      var diff = Math.max(0, target - now);
      var s = Math.floor(diff / 1000);
      var d = Math.floor(s / 86400); s -= d * 86400;
      var h = Math.floor(s / 3600);  s -= h * 3600;
      var m = Math.floor(s / 60);    s -= m * 60;

      var el;
      if ((el = ct.querySelector('[data-ct-d]'))) el.textContent = pad2(d);
      if ((el = ct.querySelector('[data-ct-h]'))) el.textContent = pad2(h);
      if ((el = ct.querySelector('[data-ct-m]'))) el.textContent = pad2(m);
      if ((el = ct.querySelector('[data-ct-s]'))) el.textContent = pad2(s);
    } catch (err) {
      console.error('[eclipse-brand-cards] updateCard failed', err, card);
    }
  }

  function tick() {
    if (document.hidden) return;
    var now = Date.now();
    var cards = document.querySelectorAll(CARD_SELECTOR);
    for (var i = 0; i < cards.length; i++) updateCard(cards[i], now);
  }

  function startGlobalTick() {
    if (tickHandle) return;
    tickHandle = setInterval(tick, 1000);
  }

  function stopGlobalTick() {
    if (!tickHandle) return;
    clearInterval(tickHandle);
    tickHandle = null;
  }

  function mount(section) {
    if (!section || mountedSections.has(section)) return;
    mountedSections.add(section);
    tick();
    startGlobalTick();
  }

  function unmount(section) {
    mountedSections.delete(section);
    if (mountedSections.size === 0) stopGlobalTick();
  }

  function init() {
    try {
      var sections = document.querySelectorAll(SECTION_SELECTOR);
      for (var i = 0; i < sections.length; i++) mount(sections[i]);
    } catch (err) {
      console.error('[eclipse-brand-cards] init failed', err);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target || !e.target.classList) return;
    if (!e.target.classList.contains(SECTION_CLASS)) return;
    mount(e.target);
  });

  document.addEventListener('shopify:section:unload', function (e) {
    if (!e.target || !e.target.classList) return;
    if (!e.target.classList.contains(SECTION_CLASS)) return;
    unmount(e.target);
  });

  document.addEventListener('shopify:block:select', function (e) {
    if (!e.target || !e.target.matches) return;
    if (!e.target.matches(CARD_SELECTOR)) return;
    updateCard(e.target, Date.now());
  });

  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) tick();
  });
})();
